export default __webpack_public_path__ + "static/media/churn_record_a_video.bfda525f.gif";